import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconStars = (props: IconProps) => {
  const { size = 26, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 26 26"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        d="M18.094 9.479c-.164.132-.336.137-.515.015-.179-.122-.238-.284-.176-.487l.814-2.647-2.058-1.461c-.174-.132-.228-.297-.162-.495.067-.197.203-.296.407-.296h2.58l.814-2.724a.424.424 0 01.17-.236.456.456 0 01.26-.084c.092 0 .18.028.261.084a.424.424 0 01.17.236l.813 2.724h2.58c.205 0 .34.099.407.296.067.198.013.363-.16.495l-2.059 1.46.814 2.648c.062.203.003.365-.176.487-.18.122-.351.117-.515-.015l-2.135-1.613-2.134 1.613zM5.843 24.256c-.368.296-.754.308-1.157.034s-.536-.64-.398-1.096l1.832-5.957-4.63-3.286c-.392-.297-.513-.668-.363-1.113.15-.445.455-.668.915-.668h5.805L9.68 6.042a.954.954 0 01.38-.53c.184-.126.38-.189.587-.189.208 0 .404.063.588.189.184.125.31.302.38.53l1.831 6.128h5.806c.46 0 .765.223.915.668.15.445.03.816-.363 1.113l-4.63 3.286 1.832 5.957c.138.457.005.822-.398 1.096-.403.274-.789.262-1.157-.034l-4.804-3.63-4.803 3.63z"
        fill="currentColor"
      />
    </Svg>
  );
};
